import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "copy",
  "use": "copy-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" fill-rule=\"evenodd\" stroke-linejoin=\"round\" stroke-miterlimit=\"2\" id=\"copy\"><path d=\"M6.047,3.989L3,3.989L3,23L18.873,23L18.878,19.816L18.896,20.011L21.92,20.011L21.947,1L6.047,1L6.047,3.989ZM17.214,21.68L4.66,21.68L4.66,5.285L17.2,5.309L17.214,21.68ZM7.707,3.989L7.707,2.296L20.247,2.32L20.261,18.691L18.879,18.691L18.9,3.989L7.707,3.989Z\" fill=\"currentColor\" fill-rule=\"nonzero\" transform=\"translate(-.473)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol